module.exports = __webpack_public_path__ + "img/authentication.afc303c1.png";